import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography, { TypographyProps } from '@mui/material/Typography';
export const OptionContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));
export const OptionCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'enabled',
})<{ enabled?: boolean }>(({ theme, enabled }) => ({
  border: '1px solid #E6E8EB',
  transition: 'all 0.2s ease',
  width: '100%',
  boxSizing: 'border-box',
  '&:hover': {
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    borderColor: theme.palette.primary.main,
  },
  ...(enabled && {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light + '10',
  }),
}));
export const OptionCardContent = styled(CardContent)(({ theme }) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  '&:last-child': {
    paddingBottom: theme.spacing(0.5),
  },
}));
export const OptionCardContentInner = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));
export const OptionInfo = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));
export const OptionInfoTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  wordBreak: 'break-word',
  fontSize: 16,
  color: theme.palette.text.primary,
}));
export const OptionInfoContactContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));
export const OptionInfoContact = styled(Typography)<TypographyProps<'a'>>(
  ({ theme }) => ({
    wordBreak: 'break-all',
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 240,
    display: 'inline-block',
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  }),
);
export const OptionPrice = styled(Typography)(() => ({
  color: 'rgb(1, 147, 1)',
  fontWeight: 700,
  fontSize: 18,
  minWidth: '80px',
  textAlign: 'right',
  whiteSpace: 'nowrap',
}));
